import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/plan`;

export default {
  async create(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/create?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },
};
